const toInteger = (value) => parseInt(value || 0, 10) || 0;

export const getOverDiscountApprovalCode = (marketingLevel) => {
  switch (Number(marketingLevel)) {
    case 1:
    case 2:
      return "APPRV0009";
    case 3:
    case 4:
      return "APPRV0010";
    case 5:
    case 6:
      return "APPRV0011";
    case 7:
      return "APPRV0012";
    case 8:
      return "APPRV0013";
    default:
      return null;
  }
};

export const isPriceDifferent = (hargaDiberikan, hargaOtrOff) =>
  toInteger(hargaDiberikan) !== toInteger(hargaOtrOff);

export const hasCashTempo = (cashTempo) => toInteger(cashTempo) > 0;

export const hasDibayarRumah = (dibayarRumah) => toInteger(dibayarRumah) > 0;

export const isDiscountBelowMinimum = (discountDiberikan, discountMin) =>
  toInteger(discountDiberikan) < toInteger(discountMin);

export const isOverDiscount = (discountDiberikan, discountMax, mk) =>
  toInteger(discountMax) - toInteger(discountDiberikan) - toInteger(mk) < 0;

export const isPromoWithinGracePeriod = (salesProgram) => {
  if (!salesProgram?.value) return false;

  const currentDate = new Date();
  return (
    currentDate > new Date(salesProgram.tanggalSelesai) &&
    currentDate <= new Date(salesProgram.gracePeriod)
  );
};

export const getOldestUnit = (units) => {
  if (!Array.isArray(units) || units.length === 0) return null;

  return units.reduce(
    (oldest, unit) =>
      Number(unit?.umur || 0) > Number(oldest?.umur || 0) ? unit : oldest,
    null
  );
};

export const isOlderThanOldestUnit = (selectedUnitAge, oldestUnitAge) => {
  if (selectedUnitAge === null || selectedUnitAge === undefined) return false;
  if (oldestUnitAge === null || oldestUnitAge === undefined) return false;

  return Number(selectedUnitAge) < Number(oldestUnitAge);
};

export const calculateFakturJualViolations = (data) => {
  const headerTransaction = data?.dataTransaction?.headerTransaction || {};
  const detailTransaction = data?.dataTransaction?.detailTransaction || {};
  const pembayaranUnit = detailTransaction.pembayaranUnit || {};
  const pembayaranKonsumen = detailTransaction.pembayaranKonsumen || {};
  const violations = [];

  if (
    isPriceDifferent(
      headerTransaction.hargaDiberikan,
      headerTransaction.hargaOtrOff
    )
  ) {
    violations.push("APPRV0008");
  }

  if (hasCashTempo(pembayaranKonsumen.cashTempo)) {
    violations.push("APPRV0014");
  }

  if (hasDibayarRumah(pembayaranKonsumen.dibayarRumah)) {
    violations.push("APPRV0015");
  }

  if (isPromoWithinGracePeriod(pembayaranUnit.salesProgramId)) {
    violations.push("APPRV0017");
  }

  if (
    isDiscountBelowMinimum(
      pembayaranUnit.discountDiberikan,
      pembayaranUnit.discountMin
    )
  ) {
    violations.push("APPRV0018");
  }

  if (
    isOverDiscount(
      pembayaranUnit.discountDiberikan,
      pembayaranUnit.discountMax,
      pembayaranUnit.mk
    )
  ) {
    const approvalCode = getOverDiscountApprovalCode(
      headerTransaction.levelMarketing
    );
    if (approvalCode) violations.push(approvalCode);
  }

  return [...new Set(violations)];
};
